import React, { useState, useEffect } from 'react';
import { Carousel as RawCarousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {
  MediaCarouselContainer,
  MediaWrapper,
  MediaImage,
  MediaModal,
  MediaModalContent,
  CloseButton,
  CountIndicator,
} from './MediaCarousel.style';
import ArrowButton from './ArrowButton';
const Carousel = RawCarousel;

const MediaCarousel: React.FC<{ media: string[] }> = ({ media }) => {
  const [isMediaOpen, setMediaOpen] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => setIsMobileView(window.innerWidth <= 768);
      setIsMobileView(window.innerWidth <= 768); // set initial value
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  const openMedia = (index: number) => {
    setCurrentIndex(index);
    setMediaOpen(true);
  };

  const closeMedia = () => {
    setMediaOpen(false);
  };

  // Show the previous image
  const prevMedia = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation(); // Prevent modal close on click
    setCurrentIndex((currentIndex - 1 + media.length) % media.length);
  };

  // Show the next image
  const nextMedia = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation(); // Prevent modal close on click
    setCurrentIndex((currentIndex + 1) % media.length);
  };

  return (
    <>
      {media?.length > 0 && (
        <MediaCarouselContainer>
          <Carousel
            className="media-carousel"
            showArrows={media?.length > 3 ? true : false}
            showThumbs={false}
            showIndicators={false}
            infiniteLoop={false}
            centerMode={true}
            centerSlidePercentage={isMobileView ? 100 : 33.33} // 100% on mobile, 33.33% on larger screens
          >
            {media.map((mediaUrl, index) => (
              <MediaWrapper key={index} onClick={() => openMedia(index)}>
                <MediaImage src={mediaUrl} alt={`Image ${index + 1}`} />
              </MediaWrapper>
            ))}
          </Carousel>

          {isMediaOpen && (
            <MediaModal onClick={closeMedia}>
              <CloseButton onClick={closeMedia} />
              <ArrowButton direction="left" onClick={prevMedia} />
              <CountIndicator>
                {currentIndex + 1} / {media.length}
              </CountIndicator>
              <MediaModalContent
                src={media[currentIndex]}
                alt={`Enlarged view ${currentIndex + 1}`}
              />
              <ArrowButton direction="right" onClick={nextMedia} />
            </MediaModal>
          )}
        </MediaCarouselContainer>
      )}
    </>
  );
};

export default MediaCarousel;
